import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { TrashFill, XCircleFill } from 'react-bootstrap-icons'
import Swal from 'sweetalert2'
import { CustomButton } from '../../../components/CustomButton'
import FuncionariosService from '../../../services/database/FuncionariosService'

export function ModalDelFunc({ funcId, isOpen, onClose, loadFuncionarios }) {
  const [requestIsLoading, setRequestIsLoading] = useState(false)

  async function handleDelFunc(id) {
    setRequestIsLoading(true)

    try {
      await FuncionariosService.delete(id)

      Swal.fire('Deletado', 'Funcionário foi deletado com sucesso!', 'success')

      await loadFuncionarios()
    } catch (err) {
      console.log(`Houve um erro ao deletar o funcionário ${id}: ${err}`)

      Swal.fire('Erro', 'Erro ao deletar funcionário', 'error')
    } finally {
      setRequestIsLoading(false)
      onClose()
    }
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Deseja deletar o funcionário?</Modal.Title>
      </Modal.Header>

      <Modal.Footer>
        <CustomButton
          title="Cancelar"
          onClick={onClose}
          color=" #818181 "
          isDisabled={requestIsLoading}
        >
          <XCircleFill />
        </CustomButton>

        <CustomButton
          isLoading={requestIsLoading}
          isDisabled={requestIsLoading}
          title="Deletar"
          color="#df0000"
          onClick={() => handleDelFunc(funcId)}
        >
          <TrashFill />
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
